import React, { useState } from 'react'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import { OutlinedInput } from '@mui/material'
import MenuItem from '@mui/material/MenuItem'

import Icon from '../../../../components/UI/Icon'
import UpcomingClassesFilter from '../UpcomingClassesFilter'

import { upcomingClassesSortOptions } from '../../../../constants'

const UpcomingClassesHeader = ({ filters, setFilters }) => {
  const [isFilterOpen, setIsFilterOpen] = useState(false)

  const handleChangeSort = (event) => {
    setFilters({
      ...filters,
      sort: event.target.value,
    })
  }

  const handleFilterOpen = () => {
    setIsFilterOpen(true)
  }

  const handleFilterClose = () => {
    setIsFilterOpen(false)
  }

  return (
    <div className="flex items-center justify-between mb-[20px]">
      <h3 className="text-2xl font-bold text-white">Upcoming Classes</h3>

      <UpcomingClassesFilter
        filters={filters}
        setFilters={setFilters}
        open={isFilterOpen}
        onClose={handleFilterClose}
      />

      <div className="flex items-center gap-x-[20px]">
        <button
          className="dropdownMenuView bg-[#FEEBDD] px-[16px] h-[44px] flex items-center"
          onClick={handleFilterOpen}
        >
          <Icon name="filter" color="#F67443" className="w-[28px] h-[28px] mr-[8px]" />

          <span className="text-base text-[#F67443] font-medium font-Inter">Filter</span>
        </button>

        <FormControl className="dropdownMenuView bg-[#FEEBDD] h-[44px]">
          <Select
            id="simple-select"
            value={filters.sort}
            displayEmpty
            onChange={handleChangeSort}
            input={
              <OutlinedInput
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'transparent',
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'transparent',
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'transparent',
                  },
                }}
              />
            }
            renderValue={(selected) => {
              const selectedItem = upcomingClassesSortOptions.find(
                (option) => option.id === selected
              )

              return <span className="text-[#F67443] mr-[30px]">{selectedItem?.value}</span>
            }}
          >
            {upcomingClassesSortOptions.map((upcomingClassesSortOption) => {
              return (
                <MenuItem
                  key={upcomingClassesSortOption.id}
                  value={upcomingClassesSortOption.id}
                  className="!text-[#F67443]"
                >
                  {upcomingClassesSortOption.value}
                </MenuItem>
              )
            })}
          </Select>
        </FormControl>
      </div>
    </div>
  )
}

export default UpcomingClassesHeader
